import * as React from 'react'

function SvgBr(props) {
	return (
		<svg viewBox="-2100 -1470 4200 2940" width="1em" height="1em" {...props}>
			<defs>
				<path
					id="br_svg__i"
					fillRule="evenodd"
					d="M-31.5 0h33a30 30 0 0030-30v-10a30 30 0 00-30-30h-33zm13-13h19a19 19 0 0019-19v-6a19 19 0 00-19-19h-19z"
				/>
				<path
					id="br_svg__j"
					transform="translate(-31.5)"
					d="M0 0h63v-13H12v-18h40v-12H12v-14h48v-13H0z"
				/>
				<path
					id="br_svg__l"
					d="M-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11H25v-12h-51.25z"
				/>
				<path
					id="br_svg__k"
					d="M-31.5 0h12v-48l14 48h11l14-48V0h12v-70H14L0-22l-14-48h-17.5z"
				/>
				<path
					id="br_svg__a"
					fillRule="evenodd"
					d="M0 0a31.5 35 0 000-70A31.5 35 0 000 0m0-13a18.5 22 0 000-44 18.5 22 0 000 44"
				/>
				<path
					id="br_svg__c"
					fillRule="evenodd"
					d="M-31.5 0h13v-26h28a22 22 0 000-44h-40zm13-39h27a9 9 0 000-18h-27z"
				/>
				<path
					id="br_svg__n"
					d="M-15.75-22C-15.75-15-9-11.5 1-11.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25C-30.5-71-6-70 3-70s26 4 25.75 21.25H13.5c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-.25 11.75 46.25 4 46.25 28.75C31.5-3.5 13.5 0 0 0c-11.5 0-31.55-4.5-31.5-22z"
				/>
				<use id="br_svg__o" xlinkHref="#br_svg__f" transform="scale(31.5)" />
				<use id="br_svg__p" xlinkHref="#br_svg__f" transform="scale(26.25)" />
				<use id="br_svg__r" xlinkHref="#br_svg__f" transform="scale(21)" />
				<use id="br_svg__q" xlinkHref="#br_svg__f" transform="scale(15)" />
				<use id="br_svg__s" xlinkHref="#br_svg__f" transform="scale(10.5)" />
				<g id="br_svg__m">
					<clipPath id="br_svg__b">
						<path d="M-31.5 0v-70h63V0zM0-47v12h31.5v-12z" />
					</clipPath>
					<use xlinkHref="#br_svg__a" clipPath="url(#br_svg__b)" />
					<path d="M5-35h26.5v10H5z" />
					<path d="M21.5-35h10V0h-10z" />
				</g>
				<g id="br_svg__h">
					<use xlinkHref="#br_svg__c" />
					<path d="M28 0c0-10 0-32-15-32H-6c22 0 22 22 22 32" />
				</g>
				<g id="br_svg__f" fill="#fff">
					<g id="br_svg__e">
						<path id="br_svg__d" transform="rotate(18 0 -1)" d="M0-1v1h.5" />
						<use xlinkHref="#br_svg__d" transform="scale(-1 1)" />
					</g>
					<use xlinkHref="#br_svg__e" transform="rotate(72)" />
					<use xlinkHref="#br_svg__e" transform="rotate(-72)" />
					<use xlinkHref="#br_svg__e" transform="rotate(144)" />
					<use xlinkHref="#br_svg__e" transform="rotate(216)" />
				</g>
			</defs>
			<rect y="-50%" x="-50%" height="100%" fill="#009b3a" width="100%" />
			<path d="M-1743 0L0 1113 1743 0 0-1113z" fill="#fedf00" />
			<circle r={735} fill="#002776" />
			<clipPath id="br_svg__g">
				<circle r={735} />
			</clipPath>
			<path
				fill="#fff"
				d="M-2205 1470a1785 1785 0 013570 0h-105a1680 1680 0 10-3360 0z"
				clipPath="url(#br_svg__g)"
			/>
			<g transform="translate(-420 1470)" fill="#009b3a">
				<use y={-1697.5} xlinkHref="#br_svg__a" transform="rotate(-7)" />
				<use y={-1697.5} xlinkHref="#br_svg__h" transform="rotate(-4)" />
				<use y={-1697.5} xlinkHref="#br_svg__i" transform="rotate(-1)" />
				<use y={-1697.5} xlinkHref="#br_svg__j" transform="rotate(2)" />
				<use y={-1697.5} xlinkHref="#br_svg__k" transform="rotate(5)" />
				<use y={-1697.5} xlinkHref="#br_svg__l" transform="rotate(9.75)" />
				<use y={-1697.5} xlinkHref="#br_svg__c" transform="rotate(14.5)" />
				<use y={-1697.5} xlinkHref="#br_svg__h" transform="rotate(17.5)" />
				<use y={-1697.5} xlinkHref="#br_svg__a" transform="rotate(20.5)" />
				<use y={-1697.5} xlinkHref="#br_svg__m" transform="rotate(23.5)" />
				<use y={-1697.5} xlinkHref="#br_svg__h" transform="rotate(26.5)" />
				<use y={-1697.5} xlinkHref="#br_svg__j" transform="rotate(29.5)" />
				<use y={-1697.5} xlinkHref="#br_svg__n" transform="rotate(32.5)" />
				<use y={-1697.5} xlinkHref="#br_svg__n" transform="rotate(35.5)" />
				<use y={-1697.5} xlinkHref="#br_svg__a" transform="rotate(38.5)" />
			</g>
			<use y={-132} x={-600} xlinkHref="#br_svg__o" />
			<use y={177} x={-535} xlinkHref="#br_svg__o" />
			<use y={243} x={-625} xlinkHref="#br_svg__p" />
			<use y={132} x={-463} xlinkHref="#br_svg__q" />
			<use y={250} x={-382} xlinkHref="#br_svg__p" />
			<use y={323} x={-404} xlinkHref="#br_svg__r" />
			<use y={-228} x={228} xlinkHref="#br_svg__o" />
			<use y={258} x={515} xlinkHref="#br_svg__o" />
			<use y={265} x={617} xlinkHref="#br_svg__r" />
			<use y={323} x={545} xlinkHref="#br_svg__p" />
			<use y={477} x={368} xlinkHref="#br_svg__p" />
			<use y={551} x={367} xlinkHref="#br_svg__r" />
			<use y={419} x={441} xlinkHref="#br_svg__r" />
			<use y={382} x={500} xlinkHref="#br_svg__p" />
			<use y={405} x={365} xlinkHref="#br_svg__r" />
			<use y={30} x={-280} xlinkHref="#br_svg__p" />
			<use y={-37} x={200} xlinkHref="#br_svg__r" />
			<use y={330} xlinkHref="#br_svg__o" />
			<use y={184} x={85} xlinkHref="#br_svg__p" />
			<use y={118} xlinkHref="#br_svg__p" />
			<use y={184} x={-74} xlinkHref="#br_svg__r" />
			<use y={235} x={-37} xlinkHref="#br_svg__q" />
			<use y={495} x={220} xlinkHref="#br_svg__p" />
			<use y={430} x={283} xlinkHref="#br_svg__r" />
			<use y={412} x={162} xlinkHref="#br_svg__r" />
			<use y={390} x={-295} xlinkHref="#br_svg__o" />
			<use y={575} xlinkHref="#br_svg__s" />
		</svg>
	)
}

export default SvgBr
